export const pages = {
  auth: {
    login: {
      title: 'Entrata'
    },
    confirmation: {
      title: 'Post conferma',
      description:
        "Ti abbiamo inviato una lettera con un codice per posta __Var_0__. L'invio può richiedere fino a un minuto"
    },
    verifyEmail: {
      title: 'Modifica della password'
    },
    reset: {
      title: 'Modifica della password'
    },
    otp: {
      title: 'Post conferma',
      description:
        "Ti abbiamo inviato una lettera con un codice per posta __Var_0__. L'invio può richiedere fino a un minuto"
    },
    register: {
      title: 'Registrazione {role}A'
    },
    invite: {
      title: 'Benvenuto in Live Bright Connect',
      description: 'Scegli la versione del tuo profilo'
    }
  },
  notification: {
    title: 'Notifiche',
    notFound: 'Non hai ancora notifiche.',
    description:
      'Puoi visualizzare nuove applicazioni dagli artisti nella sezione "artisti" nel tuo profilo'
  },
  loyalty: {
    inputLabel: 'Il tuo link:',
    registered: 'Registrato',
    followed_link: 'Passato sul collegamento',
    inputDescription:
      "Per invitare l'artista, inviare un link per la registrazione.",
    artist: {
      title: 'Invito al sito',
      description:
        "L'artista che ha completato la registrazione del tuo link è considerato invitato."
    },
    club: {
      title: 'Programma di fidelizzazione',
      note: "L'artista che ha completato la registrazione del tuo link è considerato invitato.",
      description: 'Ottieni artisti senza commissione!',
      text: "👯‍♀️ Hai avuto un casting e l'artista non si adattava? Qualcuno sta completando il contratto? Inviale il tuo link personale.",
      content:
        "Quando l'artista è registrato dal tuo link, ti ​​conta. 📌 Per ogni 5 artisti ottieni 1 contratto senza una commissione - per 1 mese di calendario. Anche se l'artista seleziona un altro club, verrà comunque presa in considerazione in banco.‼ ️ Per partecipare al programma, il tuo club deve compilare il profilo ed essere visibile nella ricerca, condividere la piattaforma e ottenere benefici ora."
    }
  },
  language: {
    title: 'Lingue',
    description: 'Scegli il linguaggio della piattaforma',
    options: {
      ru: 'Russo',
      en: 'Inglese',
      uk: 'Ucraino',
      it: 'Italiano',
      de: 'Tedesco',
      tr: 'Turco',
      es: 'Spagnolo'
    }
  },
  profilePage: {
    techSupport: 'Servizio di assistenza',
    privacy: 'Condizioni e riservatezza',
    artist: {
      work: 'Lavorare nel club',
      infoEditSection: 'Editing',
      infoAppSection: 'Applicazione',
      personalInfo: 'Informazioni personali',
      portfolio: 'Portfolio',
      invitationAndRequests: 'Applicazioni e inviti',
      hideProfile: "Nascondi l'account",
      loyaltyLink: 'Invita un amico'
    },
    club: {
      clubInfoSection: 'Informazioni sul club',
      artistsSection: 'Artisti',
      artistHiring: 'Un set di artisti',
      loyaltyProgram: 'Programma di fidelizzazione',
      editingSection: 'Editing',
      clubInfo: 'Informazioni personali',
      conditions: 'Condizioni',
      approvedArtists: 'Artisti approvati',
      requestsAndInvitations: 'Applicazioni e inviti',
      applicationSection: 'Applicazione'
    }
  },
  portfolioPage: {
    title: 'Portfolio',
    warnNotPublished:
      'Il curriculum non è pubblicato. Compila il portafoglio per pubblicare un curriculum.',
    warnfillPortfolio: 'Compila il portafoglio',
    warnf: 'Compila il portafoglio',
    warnFillSection:
      "Riempi questa sezione per aumentare le possibilità dell'invito."
  },
  profileInfo: {
    club: {
      title: 'Info'
    },
    artist: {
      title: 'Info'
    }
  },
  clubTerms: {
    title: 'Condizioni',
    description:
      "Prova a compilare completamente tutti i passaggi. L'attrattiva dell'annuncio per gli artisti dipende da questo. Gira per chiedere aiuto se sorgono difficoltà.",
    progressSteps: {
      schedule: 'Programma di lavoro del club',
      contractTerms:
        "Il contratto minimo, programma di artisti, biglietti, trasferimento dall'aeroporto",
      payments:
        'Pagamenti: scommessa, garanzia, fallo, poples, go-go, deposito, spettacolo, tè, consumo, menu pazzo',
      workConditions:
        'Tipo di consumo. Coreografo. I servizi fotografici. Piloni. Quantità',
      housing: "Informazioni sull'edilizia abitativa. Foto.",
      penalties: 'Mesh di penalità',
      photo: 'Foto del club',
      video: 'Video del club'
    }
  },
  clubEmployers: {
    title: 'Artisti approvati',
    tabs: {
      pending: 'In anticipo',
      onContract: 'Sul contratto'
    }
  },
  requestAndInvitation: {
    title: 'Applicazioni e inviti'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Ore di club',
        popups: {
          title: 'Orari di apertura'
        },
        changeAllWorkTimes: 'Cambia tutte le ore di lavoro'
      },
      contractTerms: {
        title: 'Condizioni di lavoro nel club',
        form: {
          minimalContractTerm: {
            label: 'Il termine del contratto minimo',
            unit: 'Settimane'
          },
          artistsSchedule: {
            label: 'Il programma degli artisti'
          }
        }
      },
      payments: {
        title: 'Pagamenti',
        rateFieldDescription:
          'Se hai una scommessa con un numero, compila solo uno dei campi di input'
      },
      workConditions: {
        title: 'Condizioni di lavoro nel club',
        form: {
          noExperienceEmployment: 'Occupazione di artisti senza esperienza',
          additionalInfo: {
            label: 'Ulteriori informazioni sul club',
            placeholder:
              'Puoi scrivere di promozioni o bonus nel tuo club o altre informazioni che saranno interessanti per gli artisti',
            description: 'Inserisci almeno 100 caratteri'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement: "Immettere l'elemento del codice del codice",
            description:
              'Seleziona il codice di abbigliamento per gli artisti nel tuo club. Aggiungi posizioni mancanti.'
          }
        }
      },
      housing: {
        title: "Informazioni sull'edilizia abitativa"
      },
      penalties: {
        title: 'Multe',
        description:
          "Aggiungi la tua posizione se non li hai trovati nell'elenco fornito"
      },
      photo: {
        title: 'Foto del club',
        description:
          'Scarica le foto del club. Puoi apportare modifiche in seguito',
        options: {
          hallNoGuests: 'Foto di una sala vuota',
          hallWithGuests: 'Foto della sala con gli ospiti',
          privateRooms: 'Foto di camere private',
          scene: 'Foto della scena'
        }
      },
      video: {
        title: 'Video del club',
        description:
          'Scarica il video del club. Puoi apportare modifiche in seguito',
        options: {
          ClubTour: 'Video della sala vuota',
          EventVideo: 'Video Hall con gli ospiti',
          WorkingHours: 'Scene video'
        }
      }
    },
    artist: {
      work: {
        title: 'Esperienza nei club',
        addWorkPlace: 'Aggiungi un luogo di lavoro',
        notHaveWorkExperience: 'Continua senza esperienza'
      },
      language: {
        title: 'Lingue',
        languageProfinience: 'Lingue straniere bowling'
      },
      parametres: {
        title: 'Parametri'
      },
      about: {
        title: 'Su di te',
        description: 'Scrivi di te cosa sarà interessante per il club',
        textAreaDescription: 'Inserisci almeno 100 caratteri',
        textAreaPlaceholder: 'Entrare'
      },
      video: {
        title: 'Video',
        videoForHostesVacancy: "2. Scarica l'unità video",
        videoForGogoVacancy:
          '1. Scarica il video su come balli per una ballerina di canali e vai'
      },
      photo: {
        title: 'Foto',
        description:
          'Scarica foto. Le foto dovrebbero essere senza filtri e Photoshop.',
        FaceNoMakeup: 'Il modello è una faccia senza trucco.',
        FaceWithMakeup: 'Faccia / make -up.',
        FreePose: 'Modello fotografico in una posa gratuita.',
        FullBodyOnHeels: 'Foto del modello a piena altezza con i tacchi.',
        LingerieOrSwimsuit: 'Modello fotografico in costume da bagno',
        selectMainPhoto: 'Scegli la foto principale'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: "L'artista sta già lavorando nel club",
      incompleted:
        'Per inviare inviti, è necessario compilare il tuo profilo al 100%.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Richiedi la data di fine contratto al club.',
      clubSetLastWorkDate:
        'Il club ha fissato la tua ultima data di lavoro in questo club.',
      clubNotHiring:
        'Non è possibile inviare una richiesta, poiché il club non ha aperto una serie di artisti.',
      pendingRequest:
        'Non è possibile inviare più di una richiesta entro 48 ore.',
      haveContract:
        'Non puoi inviare una richiesta, poiché hai un contratto corrente.',
      hidden:
        'Non è possibile inviare una richiesta, poiché il tuo profilo è nascosto alla ricerca.',
      incompleted:
        'Non puoi inviare una richiesta, poiché non hai compilato completamente il profilo.'
    }
  },
  notFoundWorkItem: {
    title: 'Questo invito o richiesta non esiste più.',
    description:
      'Siamo dispiaciuti, ma le pagine non esistono. Per favore, vai in vagial.'
  },
  notFoundCurrentWork: {
    title: 'Contratto attivo',
    description:
      'Al momento, non si dispone di un contratto attivo, vai alla pagina di ricerca e invia una domanda al club per avviare un contratto.'
  },
  clubFullProfile: {
    clubVideo: 'Video del club',
    clubPhoto: 'Foto del club',
    clubHousingPhoto: 'Foto di alloggi',
    minimalContractDuration: 'Contratto minimo',
    artistWorkSchedule: 'Programma di lavoro',
    paymentFrequescyMessage: "Pagamenti all'artista per la consumo - 1 volta in"
  },
  privacyPolicy: {
    title: "Accordo sull'utente e Informativa sulla privacy"
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Invita un manager a chattare',
      managerIsInChat: 'Chat Manager',
      manageRequestPending: 'Il gestore verrà aggiunto presto'
    },
    admin: {
      assistanceProvided: 'Viene fornito aiuto',
      openDirectChat: 'Apri chat diretta',
      openWhatsApp: 'Apri WhatsApp',
      phoneNumberNotAvailable: 'Numero di telefono non disponibile'
    }
  }
};
